import { ReactNode } from "react";
import Button from "../Button/Button";
import './pageHeader.style.sass'

interface PageHeaderAction {
    icon?: ReactNode;
    fn: () => void;
    content: string;
}
interface PageHeaderProps {
    title: string;
    actions?: PageHeaderAction[]
}

/**
 * Displays a title with buttons 
 * @props title
 * @props actions - list of buttons to display. Can display an icon if needed.
*/
export const PageHeader = ({ title, actions = [] }: PageHeaderProps) => {
    const makeActionLabel = (action: PageHeaderAction) => {
        if (action.icon) {
            return <span>{action.icon} {action.content}</span>
        } else {
            return <span>{action.content}</span>
        }
    }
    const generateActions = () => {
        if (actions) {
            return actions.map((action: PageHeaderAction) => {
                return <Button
                    preset="primary"
                    fn={() => action.fn()}
                    key={action.content}
                >
                    {makeActionLabel(action)}
                </Button>
            })
        }
    }
    return <header className="page-header">
        <h1>{title}</h1>
        <div className="actions">{generateActions()}</div>
    </header>

}
